import { _ } from "libs";
import { Match, MatchScore } from "../../types";
import React, { FC, useEffect, useState } from "react";
import { getMatches } from "../../actions";
import Loader from "../loader";
import moment from "moment";
import MatchItemMedium from "../items/match/medium";

type MatchesListProps = {
	championshipId?: string;
	viewForPlayerId?: string;
	showPractice: boolean;
	showUnconfirmed: boolean;
};

type MatchProps = {
	match: Match;
	viewForPlayerId?: string;
};

const getOpponent = (match: Match, viewForPlayerId: string) => {
	return match.playerA?.userId === viewForPlayerId ? match.playerB : match.playerA;
};

const getScore = (score?: MatchScore[]) => {
	if (!score) {
		return null;
	}

	const [scoreA, scoreB] = score;

	if (!scoreA || !scoreB) {
		return null;
	}
	let result = [];

	for (let i = 0; i < scoreA.score?.length; i++) {
		result.push([scoreA.score?.[i], scoreB.score?.[i]].join("-"));
	}

	return result.length ? result.join(" ") : null;
};

// const MatchRow: FC<MatchProps> = ({ match, viewForPlayerId }: MatchProps) => {
// 	const opponent = getOpponent(match, viewForPlayerId);
// 	let fullName = [opponent?.firstName, opponent?.lastName].join(" ").trim();
// 	fullName = fullName.length ? fullName : "GotCourts player";
// 	const league = getLeagueInfo(match.championship, opponent?.leagueId);
// 	const score = getScore(match?.score);
// 	return (
// 		<div>
// 			<div>
// 				{match.winnerId === viewForPlayerId
// 					? _("championship.matches.winner")
// 					: _("championship.matches.looser")}
// 			</div>
// 			<div className={cx("item", "player", "medium")}>
// 				<div className={cx("itemImage", { itemImageWithRing: league })}>
// 					<Avatar photoUrl={opponent?.photoUrl} size="thumb6" showLeagueRing={true} league={league} />
// 				</div>
// 			</div>
// 			<div>{opponent?.rank}</div>
// 			<div>{fullName}</div>
// 			<div>{moment.unix(match.date).fromNow()}</div>
// 			{score && <div>{score}</div>}
// 		</div>
// 	);
// };

export const MatchesList: FC<MatchesListProps> = ({
	championshipId,
	viewForPlayerId,
	showPractice = false,
	showUnconfirmed = false,
}: MatchesListProps) => {
	const [matches, setMatches] = useState([] as Match[]);
	const [matchesLoading, setMatchesLoading] = useState(true);

	useEffect(() => {
		getMatches({ playerId: viewForPlayerId, championshipId })
			.then(
				res => setMatches(res),
				err => setMatchesLoading(false)
			)
			.then(res => setMatchesLoading(false));
	}, [championshipId, viewForPlayerId]);

	const filterMatch = (match: Match, index: number) => {
		if (showPractice && showUnconfirmed) {
			return true;
		}

		let show = true;

		if (!showPractice) {
			show = match.practice === false;
		}

		if (!showUnconfirmed) {
			show = match.confirmed === true;
		}
		return show;
	};

	return (
		<div className="table tightSpacing">
			{!matchesLoading ? (
				matches.length === 0 ? (
					<div className="noResults">
						<p>{_("championship.playedMatches.noResults")}</p>
					</div>
				) : (
					matches.filter(filterMatch).map((match, index) => {
						const opponent = getOpponent(match, viewForPlayerId);
						let fullName = [opponent?.firstName, opponent?.lastName].join(" ").trim();
						fullName = fullName.length ? fullName : "GotCourts player";
						const score = getScore(match?.score);
						const time = moment.unix(match?.date).fromNow();
						return (
							<div className="cell" key={"match_" + match?.uuid + "_" + index}>
								<MatchItemMedium
									result={match?.winnerId === viewForPlayerId}
									name={fullName}
									meta={[time, score].join(" • ")}
									photoUrl={opponent?.photoUrl}
									leagueId={opponent?.leagueId}
									championship={match?.championship}
								/>
							</div>
						);
					})
				)
			) : (
				<Loader />
			)}
		</div>
	);
};
